import PropTypes from 'prop-types';

import { TextField } from '@mui/material';

export const Textarea = ({ onChange, label, value, error }) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      value={value}
      error={!!error}
      helperText={error}
      onChange={(event) => onChange(event.target.value)}
      multiline
      maxRows={4}
      fullWidth
    />
  );
};

Textarea.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
};
